import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import OSS from 'ali-oss';
import { v4 as uuidv4 } from "uuid";
import api from '@/api';
export default {
  props: {
    VideoPath: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      uploadImgUrl: process.env.VUE_APP_API + "upload-video",
      // 上传的视频服务器地址
      videoFlag: false,
      videoUploadPercent: 0,
      cancel: false,
      isUp: false,
      url: '',
      client: null
    };
  },
  created: function created() {},
  watch: {
    VideoPath: function VideoPath(val) {
      this.url = val;
    }
  },
  methods: {
    httpRequest: function httpRequest() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, file, fileSize, _yield$api$uploadPara, data, suffix, url, options, _yield$_this$client$m, res, name, videoUrl;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isUp = true;
                _this.videoUploadPercent = 0;
                _this.url = '';

                _this.$emit('Change', '');

                that = _this;
                file = _this.$refs.inputer.files[0];
                fileSize = file.size / 1024 / 1024 < 1000;

                if (!(['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1)) {
                  _context.next = 10;
                  break;
                }

                _this.$notify.warning({
                  title: "警告",
                  message: "请上传正确的视频格式"
                });

                return _context.abrupt("return", false);

              case 10:
                if (fileSize) {
                  _context.next = 13;
                  break;
                }

                _this.$notify.warning({
                  title: "警告",
                  message: "视频大小不能超过1000MB"
                });

                return _context.abrupt("return", false);

              case 13:
                _context.next = 15;
                return api.uploadParams();

              case 15:
                _yield$api$uploadPara = _context.sent;
                data = _yield$api$uploadPara.data;

                if (data.access_key_id) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return");

              case 19:
                _this.client = new OSS({
                  region: data.region,
                  bucket: data.bucket,
                  stsToken: data.sts_token,
                  accessKeyId: data.access_key_id,
                  //AccessKey
                  accessKeySecret: data.access_key_secret //秘钥

                });
                suffix = file.name.substr(file.name.indexOf('.'));
                url = '/video/' + uuidv4() + suffix;
                options = {
                  // 获取分片上传进度、断点和返回值。
                  progress: function progress(p, cpt, res) {
                    _this.videoUploadPercent = Math.floor(p * 100);

                    if (_this.cancel) {
                      _this.client.abortMultipartUpload(cpt.name, cpt.uploadId);

                      _this.cancel = false;
                    }
                  },
                  // 设置并发上传的分片数量。
                  parallel: 4,
                  // 设置分片大小。默认值为1 MB，最小值为100 KB。
                  partSize: 1024 * 1024,
                  // headers,
                  // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
                  // meta: { year: 2020, people: "test" },
                  mime: "text/plain"
                };
                _context.prev = 23;
                _context.next = 26;
                return _this.client.multipartUpload(url, file, options);

              case 26:
                _yield$_this$client$m = _context.sent;
                res = _yield$_this$client$m.res;
                name = _yield$_this$client$m.name;

                if (res.status == 200) {
                  videoUrl = data.access_daemon + name;
                  that.onSuccess(videoUrl);
                }

                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](23);
                that.onError('上传失败');

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[23, 32]]);
      }))();
    },
    inputChange: function inputChange() {
      this.cancel = false;
      this.$refs.inputer.value = '';
      this.$refs.inputer.click();
    },
    onError: function onError(e) {
      this.url = '';
      this.isUp = false;
      this.$emit('Change', '');
    },
    onSuccess: function onSuccess(e) {
      this.url = e;
      this.isUp = false;
      this.$emit('Change', e);
    },
    cancelUp: function cancelUp(e) {
      this.$refs.inputer.value = '';
      this.cancel = true;
    }
  }
};